import type { QuizPlayerScore } from '@mentimeter/quiz-types';
import { usePreviewResultsIterator } from '@mentimeter/slides-preview-results';
import { useCallback, useMemo } from 'react';

interface UseQuizOpenPreviewResultsProps {
  isPreviewResultsEnabled: boolean;
  correctAnswer: string | undefined;
}

export const useQuizOpenPreviewResultsLegacy = ({
  isPreviewResultsEnabled,
  correctAnswer,
}: UseQuizOpenPreviewResultsProps) => {
  const staticPreviewResult: QuizPlayerScore[] = useMemo(() => {
    const firstCorrectAnswer = correctAnswer ?? 'Maybe correct answer';

    return [
      {
        player: {
          identifier: 'preview-results-player-1',
          name: 'Shammy',
          emojiShortname: ':four_leaf_clover:',
          emojiName: 'Shammy',
          index: 0,
        },
        score: {
          total: {
            totalScore: 500,
            position: 1,
          },
          question: {
            score: 0,
            answer: 'Incorrect answer',
            markedCorrect: false,
          },
        },
      },
      {
        player: {
          identifier: 'preview-results-player-2',
          name: 'Ted',
          emojiShortname: ':bear:',
          emojiName: 'Ted',
          index: 2,
        },
        score: {
          total: {
            totalScore: 100,
            position: 3,
          },
          question: {
            score: 50,
            answer: firstCorrectAnswer,
            markedCorrect: true,
          },
        },
      },
      {
        player: {
          identifier: 'preview-results-player-3',
          name: 'Pingu',
          emojiShortname: ':penguin:',
          emojiName: 'Pingu',
          index: 3,
        },
        score: {
          total: {
            totalScore: 300,
            position: 2,
          },
          question: {
            score: 50,
            answer: 'Not so correct answer',
            markedCorrect: false,
          },
        },
      },
    ];
  }, [correctAnswer]);

  const getNextResults = useCallback(
    (iteration: number, _: any) => {
      return iteration % 2 === 0 ? staticPreviewResult : [];
    },
    [staticPreviewResult],
  );

  const getIntervalOpen = useCallback((iteration: number) => {
    if (iteration % 2 === 0) {
      return 4000;
    } else {
      return 600;
    }
  }, []);

  return (
    usePreviewResultsIterator<QuizPlayerScore[]>(
      isPreviewResultsEnabled,
      getNextResults,
      getIntervalOpen,
    ) ?? []
  );
};
